import React, { useEffect, useState } from "react";
import { Card, Table, Button, Row, Col, Form, Image, Pagination } from '@themesberg/react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import api from "../../utils/api";
import Swal from "sweetalert2";

export default function ContentList() {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/content-pages`, { params: { page, perPage, search } });
      if (!data.error) {
        setItems(data.data);
        setTotal(data.total);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, [page, perPage]);

  /* const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Delete this news item?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel',
      heightAuto: false
    });
    if (!result.isConfirmed) return;
    try {
      await api.delete(`/news/${id}`);
      await Swal.fire({ title: 'Deleted!', text: 'News item was deleted.', icon: 'success', timer: 1500, showConfirmButton: false, heightAuto: false });
      fetchData();
    } catch (e) {
      await Swal.fire({ title: 'Error', text: e?.response?.data?.message || e.message || 'Failed to delete', icon: 'error', heightAuto: false });
    }
  }; */

  const totalPages = Math.ceil(total / perPage) || 1;

  const handleView = async (id) => {
    try {
      const { data } = await api.get(`/content-pages/${id}`);
      const n = data.data || {};      
      const contentHtml = `
        <div style="text-align:left">          
          <div style="">${(n.body || '').toString()}</div>
        </div>
      `;
      await Swal.fire({
        title: n.title || 'Page Content',
        html: contentHtml,
        width: 1200,
        heightAuto: false
      });
    } catch (e) {
      await Swal.fire({ title: 'Error', text: e?.response?.data?.message || e.message || 'Failed to load content', icon: 'error', heightAuto: false });
    }
  };

  return (
    <Card className="shadow-sm">
      <Card.Header>
        <Row className="align-items-center">
          <Col><h5 className="mb-0">Content Page Settings</h5></Col>          
        </Row>
        <Row className="mt-3">
          <Col md={6}>
            <Form.Control placeholder="Search..." value={search} onChange={(e)=>setSearch(e.target.value)} />
          </Col>
          <Col md={2}>
            <Button variant="outline-secondary" onClick={()=>{ setPage(1); fetchData(); }}>Search</Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Table responsive hover className="align-items-center">
          <thead>
            <tr>
              <th>#</th>              
              <th>Title</th>
              {/* <th>Body</th>   */}            
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((n, index) => (
              <tr key={n.id}>
                <td>{(page - 1) * perPage + index + 1}</td>
                <td>{n.title}</td>
                {/* <td style={{ whiteSpace: 'pre-wrap' }}>{n.body || '-'}</td> */}
                <td>
                  <Button size="sm" variant="outline-info" className="me-2" onClick={()=>handleView(n.id)}>View</Button>
                  <Button size="sm" variant="outline-secondary" as={Link} to={`/content-pages/${n.id}/edit`} className="me-2">Edit</Button>                  
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={6} className="text-center">{loading ? 'Loading...' : 'No data'}</td></tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center">
          <Form.Select style={{ maxWidth: 120 }} value={perPage} onChange={(e)=>{ setPerPage(parseInt(e.target.value,10)); setPage(1); }}>
            {[10,20,50].map(n=> <option key={n} value={n}>{n} / page</option>)}
          </Form.Select>
          <Pagination className="mb-0">

            {/* Prev */}
            <Pagination.Prev
              disabled={page <= 1}
              onClick={() => setPage((p) => Math.max(1, p - 1))}
            />

            {/* Page numbers: previous */}
            {page > 1 && (
              <Pagination.Item onClick={() => setPage(page - 1)}>
                {page - 1}
              </Pagination.Item>
            )}

            {/* Active page */}
            <Pagination.Item active>{page}</Pagination.Item>

            {/* Page numbers: next */}
            {page < totalPages && (
              <Pagination.Item onClick={() => setPage(page + 1)}>
                {page + 1}
              </Pagination.Item>
            )}

            {/* Next */}
            <Pagination.Next
              disabled={page >= totalPages}
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            />

          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
}


